import { render } from "./ModalManageSanad.vue?vue&type=template&id=4ac8ca36&scoped=true"
import script from "./ModalManageSanad.vue?vue&type=script&lang=js"
export * from "./ModalManageSanad.vue?vue&type=script&lang=js"

import "./ModalManageSanad.vue?vue&type=style&index=0&id=4ac8ca36&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4ac8ca36"]])

export default __exports__